// src/components/ProtectedRoute.js
import React from "react";
import { useAuth } from "../context/authContext";
import { Navigate, useLocation } from "react-router-dom";
import logo from "../assets/Logo.png";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 🔹 Pantalla de carga mientras valida sesión
  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800">
        <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-xl p-8 w-[350px] text-center">
          <img src={logo} alt="Logo" className="mx-auto w-32 mb-6 animate-pulse" />
          <h1 className="text-xl font-bold text-white">Cargando sesión...</h1>
          <div className="mt-6 flex justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-green-500 border-solid"></div>
          </div>
        </div>
      </div>
    );
  }

  // 🔹 Si no hay usuario tras validar → login
  if (!user) return <Navigate to="/login" />;

  const currentPath = location.pathname.toLowerCase();

  console.log("[ProtectedRoute] currentPath:", currentPath, "ultimoContexto:", user?.ultimoContexto);

  // 🔹 Usuario sin gym/clase asignado → enviar a comprobación
  if (
    (!user.nombreGym || user.nombreGym === "") &&
    currentPath !== "/comprobacion" &&
    currentPath !== "/comprar-tokens" &&
    currentPath !== "/ranking" &&
    currentPath !== "/historial"
  ) {
    console.log("[ProtectedRoute] Usuario sin clase, redirigiendo a /comprobacion");
    return <Navigate to="/comprobacion" replace />;
  }

  // ✅ Usuario validado y en ruta correcta
  return <>{children}</>;
}
